import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{
			title: 'led_indicators',
			component: 'led_indicators_plug',
		},
		{
			title: 'led_indicator_color_mode',
			component: 'led_indicator_color_plus_plug_s',
		},
		{
			title: 'led_indicator_night_mode',
			component: 'led_indicator_night_mode_plus_plug_s',
		},
		{
			title: 'operational_counters',
			component: 'operational_counters_g2',
			requires_operational_counters: true,
		},
		{ title: 'device_name', component: 'device_name_g2' },
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_g2_plug_pm',
		},
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
